
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Club } from '@/types/clubs';

interface ClubSidebarProps {
  club: Club;
}

const ClubSidebar: React.FC<ClubSidebarProps> = ({ club }) => {
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-medium mb-4">About this Club</h3>
        <ul className="space-y-3">
          <li className="flex justify-between">
            <span className="text-muted-foreground">Category</span>
            <span className="font-medium">{club.category}</span>
          </li>
          <li className="flex justify-between">
            <span className="text-muted-foreground">Members</span>
            <span className="font-medium">{club.member_count}</span>
          </li>
          <li className="flex justify-between">
            <span className="text-muted-foreground">Created</span>
            <span className="font-medium">{new Date(club.created_at || '').toLocaleDateString()}</span>
          </li>
        </ul>
      </CardContent>
    </Card>
  );
};

export default ClubSidebar;
